var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepDone = function SvgStepDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stepper/desktop/atom"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 11,
    cy: 11,
    r: 9,
    fill: "#1576E1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkbox/check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M9.69047 14.6667L15.5833 8.66667L14.2738 7.33333L9.69047 12L7.72619 9.99999L6.41667 11.3333L9.69047 14.6667Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  })))));
};
export default SvgStepDone;